import { useEvent } from "react-use";
export function useWindowFocus(callback: () => unknown) {
	useEvent("focus", callback, window);
}
